module.exports = __webpack_public_path__ + "dist/img/multi-screen.9b463e68.webp";